const getDefaultState = () => {
    return {
        sender: null,
        receiver: null,
        subject: '',
        firstPartEmail: '',
        lastPartEmail: '',
        signature: '',
        selectedFields: {},
        emailsValid: [],
        emailsWrong: [],
        alreadyInCampaign: [],
        sentAt: null,
        selectedCategories: [],
        selectedCommunes: [],
        selectedTourismSectors: [],
        selectedTags: [],
        selectedApidaeSelection: null,
        selectedCriterias: [],
        providers: [],
        currentStep: 1,
        mediaSuggestion: false,
        noEmail: false,
        singleEmail: true,
        periodsConfig: 'DEFAULT',
        editedTabulations: [],
        txtIntro: null,
        txtIntroAspect: null,
        txtIntroCmaj: null,
    }
}

const createCmaj = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setCurrentStep(state, value) {
            state.currentStep = value
        },
        setSender(state, value) {
            state.sender = value
        },
        setReceiver(state, value) {
            state.receiver = value
        },
        setSubject(state, value) {
            state.subject = value
        },
        setFirstPartMail(state, value) {
            state.firstPartEmail = value
        },
        setLastPartMail(state, value) {
            state.lastPartEmail = value
        },
        setSignature(state, value) {
            state.signature = value
        },
        setSelectedFields(state, [index, value]) {
            state.selectedFields[index] = value
        },
        setEmailsValid(state, value) {
            state.emailsValid = value
        },
        setEmailsWrong(state, value) {
            state.emailsWrong = value
        },
        setAlreadyInCampaign(state, value) {
            state.alreadyInCampaign = value
        },
        setSentAt(state, value) {
            state.sentAt = value
        },
        setSelectedCategories(state, value) {
            state.selectedCategories = value
        },
        setSelectedCommunes(state, value) {
            state.selectedCommunes = value
        },
        setSelectedTourismSectors(state, value) {
          state.selectedTourismSectors = value
        },
        setSelectedApidaeSelection(state, value) {
            state.selectedApidaeSelection = value
        },
        setSelectedCriterias(state, value) {
            state.selectedCriterias = value
        },
        setSelectedTags(state, value) {
            state.selectedTags = value
        },
        setProviders(state, value) {
            state.providers = value
        },
        setProviderByIndex(state, [index, value]) {
            state.providers[index] = value
        },
        setMediaSuggestion(state, value) {
            state.mediaSuggestion = value
        },
        setPeriodsConfig(state, value) {
            state.periodsConfig = value
        },
        setNoEmail(state, value) {
            state.noEmail = value
        },
        setSingleEmail(state, value) {
            state.singleEmail = value
        },
        setTxtIntro(state, value) {
          state.txtIntro = value
        },
        setTxtIntroAspect(state, value) {
            state.txtIntroAspect = value
        },
        setTxtIntroCmaj(state, value) {
            state.txtIntroCmaj = value
        },
        addEditedTabulation(state, value) {
          state.editedTabulations.push(value)
        },
        deleteEditedTabulation(state, index) {
          state.editedTabulations.splice(index, 1)
        },
        resetEditedTabulations(state) {
          state.editedTabulations = []
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default createCmaj